import React, {useContext} from "react"
import {Panel, DataRow} from "../PDFPrimitives"
import {PDFContext} from "../BasePDF"

export const ResidualInformationPDF = ({isDealerDisclosure}) => {
    const pdfData = useContext(PDFContext)
    if (!pdfData) return null

    const rows = [
        ['MSRP', pdfData.msrp.toDollarFormat()],
    ]
    // Lease MRM exceeded: both null unless the lender capped the residualized MSRP.
    if (pdfData.msrp_adjusted != null && pdfData.mrm_adjustment != null) {
        rows.push(
            ['Maximum Residualized MSRP', pdfData.msrp_adjusted.toDollarFormat()],
            ['MSRP Adjustment',           pdfData.mrm_adjustment.toDollarFormat()],
        )
    }
    if (pdfData.max_advance && isDealerDisclosure) {
        rows.push(['Max Advance', pdfData.max_advance.toDollarFormat()])
    }
    rows.push(
        ['Residual Percentage', `${pdfData.residual_percentage}%`],
        ['Annual Mileage',      String(pdfData.annual_mileage)],
        ['Residual Amount',     pdfData.total_residual.toDollarFormat()],
    )

    return (
        <Panel title="Residual Information">
            {rows.map(([label, value], i) => (
                <DataRow
                    key={label}
                    label={label}
                    value={value}
                    isLast={i === rows.length - 1}
                />
            ))}
        </Panel>
    )
}
